/**
 * Utility functions for generating and managing data-testid attributes
 */

/**
 * @deprecated This function causes hydration mismatches in SSR/Next.js because
 * the global counter can have different values on server vs client.
 * Use React's useId() hook instead for SSR-safe unique IDs.
 *
 * Example:
 * ```tsx
 * const reactId = useId();
 * const safeId = reactId.replace(/:/g, "");
 * const testId = `button-${safeId}`;
 * ```
 */
export function generateTestId(baseName: string, suffix?: string): string {
  // Note: This counter-based approach is NOT SSR-safe
  let testIdCounter = 0;
  testIdCounter++;
  if (suffix) {
    return `${baseName}-${suffix}-${testIdCounter}`;
  }
  return `${baseName}-${testIdCounter}`;
}

/**
 * Sanitizes a string to be used in a test ID (kebab-case)
 */
export function sanitizeForTestId(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

/**
 * @deprecated This function causes hydration mismatches in SSR/Next.js because
 * the counter can have different values on server vs client.
 * Use React's useId() hook instead for SSR-safe unique IDs.
 */
export function createTestIdGenerator(componentPrefix: string) {
  let localCounter = 0;

  return (suffix?: string) => {
    localCounter++;
    if (suffix) {
      return `${componentPrefix}-${suffix}-${localCounter}`;
    }
    return `${componentPrefix}-${localCounter}`;
  };
}

/**
 * Best practice recommendation: For components with multiple similar elements,
 * use explicit data-testid props to ensure reliable test selectors.
 */
